import { render, staticRenderFns } from "./IbGridViewPlaceholderCard.vue?vue&type=template&id=2fb63fe4&scoped=true"
import script from "./IbGridViewPlaceholderCard.vue?vue&type=script&lang=js"
export * from "./IbGridViewPlaceholderCard.vue?vue&type=script&lang=js"
import style0 from "./IbGridViewPlaceholderCard.vue?vue&type=style&index=0&id=2fb63fe4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb63fe4",
  null
  
)

export default component.exports